import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const closeMenu = () => setIsOpen(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const [activeSection, setActiveSection] = useState("");

  const scrollOnHome = (hash) => {
    closeMenu();
    if (location.pathname !== "/") {
      navigate({ pathname: "/", hash });
    } else {
      const id = hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 50);
    }
  };

  const navItems = useMemo(
    () => [
      { label: "Home", to: "/", type: "route" },
      { label: "About", hash: "#about", type: "scroll", sectionId: "about" },
      { label: "Trades", to: "/trades", type: "route" },
      { label: "Faculties", to: "/faculties", type: "route" },
      { label: "Gallery", to: "/gallery", type: "route" },
      { label: "Admissions", hash: "#admissions", type: "scroll", sectionId: "admissions" },
      { label: "Contact", to: "/contact", type: "route" },
    ],
    []
  );

  const routeIsActive = (item) => {
    if (!item.to) return false;
    if (item.to === "/") return location.pathname === "/";
    return location.pathname === item.to;
  };

  useEffect(() => {
    if (location.pathname !== "/") {
      setActiveSection("");
      return undefined;
    }

    const ids = navItems
      .filter((x) => x.type === "scroll" && x.sectionId)
      .map((x) => x.sectionId)
      .filter(Boolean);

    const els = ids.map((id) => document.getElementById(id)).filter(Boolean);
    if (!els.length) return undefined;

    const obs = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => (b.intersectionRatio || 0) - (a.intersectionRatio || 0))[0];
        if (visible?.target?.id) setActiveSection(visible.target.id);
      },
      { root: null, threshold: [0.2, 0.35, 0.5, 0.7], rootMargin: "-20% 0px -60% 0px" }
    );

    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [location.pathname, navItems]);

  return (
    <nav className="navbar navbar-marketing">
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          Government ITI Harihara
        </Link>

        <div className={`menu-icon ${isOpen ? "open" : ""}`} onClick={toggleMenu} role="presentation">
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </div>

        <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
          {navItems.map((item) => (
            <li key={item.label} className="nav-item">
              {item.type === "route" ? (
                <Link
                  to={item.to}
                  className={`nav-link ${routeIsActive(item) ? "active" : ""}`}
                  onClick={closeMenu}
                >
                  {item.label}
                </Link>
              ) : (
                <button
                  type="button"
                  className={`nav-link nav-link-btn ${activeSection === item.sectionId ? "active" : ""}`}
                  onClick={() => scrollOnHome(item.hash)}
                >
                  {item.label}
                </button>
              )}
            </li>
          ))}
          <li className="nav-item nav-cta-wrap">
            <button type="button" className="nav-cta-apply" onClick={() => scrollOnHome("#enquiry")}>
              Apply Now
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
